<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card v-if="isFilled">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment_ind</md-icon>
          </div>
          <h4 class="title">
            {{ providerInfo.providerData.name }}
            {{ providerInfo.providerData.lastName }}
            {{ providerInfo.providerData.mothersLastName }}
            <span
              class="text-bold"
            >({{ providerInfo.providerData.number }})</span>
            <span class="status" :class="applyClass()">{{ providerInfo.providerData.status }}</span>
          </h4>
        </md-card-header>

        <md-card-content>
          <tabs :options="{ useUrlFragment: false }">
            <tab name="Información general">
              <form
                novalidate
                id="provider_form"
                @submit.prevent="submit"
                class="md-layout md-gutter"
              >
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('providerType') && touched.providerType,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('providerType') },
                    ]"
                  >
                    <md-icon>supervised_user_circle</md-icon>
                    <label>Tipo de proveedor</label>
                    <md-select
                      multiple
                      required
                      name="providerType"
                      v-model="providerInfo.providerType"
                      data-vv-name="providerType"
                      v-validate="modelValidations.providerType"
                    >
                      <md-option
                        v-for="type in mProviderTypes"
                        :key="type.id"
                        :value="type.id"
                      >{{ type.name }}</md-option>
                    </md-select>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('providerType')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="
                          !errors.has('providerType') && touched.providerType
                        "
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('coreBusiness') && touched.coreBusiness,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('coreBusiness') },
                    ]"
                  >
                    <md-icon>domain</md-icon>
                    <label>Giro empresarial</label>
                    <md-select
                      multiple
                      required
                      name="coreBusiness"
                      v-model="providerInfo.coreBusiness"
                      data-vv-name="coreBusiness"
                      v-validate="modelValidations.coreBusiness"
                    >
                      <md-option
                        v-for="cb in mCoreBusiness"
                        :key="cb.id"
                        :value="cb.id"
                      >{{ cb.name }}</md-option>
                    </md-select>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('coreBusiness')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="
                          !errors.has('coreBusiness') && touched.coreBusiness
                        "
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field
                    :class="[
                      { 'md-valid': !errors.has('camps') && touched.camps },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('camps') },
                    ]"
                  >
                    <md-icon>domain</md-icon>
                    <label>Campamentos</label>
                    <md-select
                      multiple
                      required
                      name="camps"
                      v-model="providerInfo.camps"
                      data-vv-name="camps"
                      v-validate="modelValidations.camps"
                    >
                      <md-option
                        v-for="camp in mCamps"
                        :key="camp.id"
                        :value="camp.id"
                      >{{ camp.name }}</md-option>
                    </md-select>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('camps')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="!errors.has('camps') && touched.camps">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-66 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('commercialName') &&
                          touched.commercialName,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('commercialName') },
                    ]"
                  >
                    <md-icon>gavel</md-icon>
                    <label>Nombre comercial</label>
                    <md-input
                      v-model="providerInfo.commercialName"
                      data-vv-name="commercialName"
                      type="text"
                      name="commercialName"
                      required
                      v-validate="modelValidations.commercialName"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('commercialName')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="
                          !errors.has('commercialName') &&
                          touched.commercialName
                        "
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid': !errors.has('capacity') && touched.capacity,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('capacity') },
                    ]"
                  >
                    <md-icon>build</md-icon>
                    <label>Capacidad</label>
                    <md-input
                      v-model="providerInfo.capacity"
                      data-vv-name="capacity"
                      type="text"
                      name="capacity"
                      required
                      v-validate="modelValidations.capacity"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('capacity')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="!errors.has('capacity') && touched.capacity"
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-100 md-small-size-100">
                  <md-switch v-model="providerInfo.doesBill">¿Factura?</md-switch>
                </div>

                <div
                  v-show="providerInfo.doesBill"
                  class="md-layout-item md-size-50 md-small-size-100"
                >
                  <md-field
                    :class="[
                      { 'md-valid': !errors.has('rfc') && touched.rfc },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('rfc') },
                    ]"
                  >
                    <md-icon>fingerprint</md-icon>
                    <label>RFC</label>
                    <md-input
                      name="rfc"
                      type="text"
                      v-model="providerInfo.rfc"
                      data-vv-name="rfc"
                      v-validate="bankEditValidations.rfc"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('rfc')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="!errors.has('rfc') && touched.rfc">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div
                  v-show="providerInfo.doesBill"
                  class="md-layout-item md-size-50 md-small-size-100 ml-auto"
                >
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('bill_zone') && touched.bill_zone,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('bill_zone') },
                    ]"
                  >
                    <md-icon>explore</md-icon>
                    <label>Zona de facturación</label>
                    <md-select
                      name="bill_zone"
                      v-model="providerInfo.bill_zone"
                      data-vv-name="bill_zone"
                      v-validate="modelValidations.bill_zone"
                    >
                      <md-option
                        v-for="zone in mStates"
                        :key="zone.id"
                        :value="zone.id"
                      >{{ zone.name }}</md-option>
                    </md-select>
                    <slide-y-down-transition>
                      <md-icon v-show="errors.has('bill_zone')" class="error">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        v-show="!errors.has('bill_zone') && touched.bill_zone"
                        class="success"
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-25 md-small-size-100">
                  <label class="md-layout-item md-size-25 md-form-label"></label>
                  <div class="md-layout-item">
                    <md-checkbox
                      class="md-primary"
                      v-model="providerInfo.resico"
                      :disabled="providerInfo.retentionFourPercent"
                    >Resico</md-checkbox>
                  </div>
                </div>
                <div class="md-layout-item md-size-25 md-small-size-100">
                  <label class="md-layout-item md-size-25 md-form-label"></label>
                  <div class="md-layout-item">
                    <md-checkbox
                      class="md-primary"
                      v-model="providerInfo.retentionFourPercent"
                      :disabled="providerInfo.resico"
                    >4%</md-checkbox>
                  </div>
                </div>
                <div class="md-layout-item md-size-25 md-small-size-100">
                  <label class="md-layout-item md-size-25 md-form-label"></label>
                  <div class="md-layout-item">
                    <md-checkbox
                      class="md-primary"
                      v-model="providerInfo.retentionEightPercent"
                      :disabled="providerInfo.taxFree"
                    >8%</md-checkbox>
                  </div>
                </div>
                <div class="md-layout-item md-size-25 md-small-size-100">
                  <label class="md-layout-item md-size-25 md-form-label"></label>
                  <div class="md-layout-item">
                    <md-checkbox
                      class="md-primary"
                      v-model="providerInfo.taxFree"
                      :disabled="providerInfo.retentionEightPercent"
                    >Exento de IVA</md-checkbox>
                  </div>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-switch v-model="modifyBank">
                    <p style="color: black">
                      <strong>¿Modificar cuenta de banco?</strong>
                    </p>
                  </md-switch>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-switch v-model="modifyContact">
                    <p style="color: black">
                      <strong>¿Modificar datos de contacto?</strong>
                    </p>
                  </md-switch>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-switch v-model="modifySecondContact">
                    <p style="color: black">
                      <strong>¿Agregar/Modificar segunda dirección?</strong>
                    </p>
                  </md-switch>
                </div>
                <div v-show="modifyBank" class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="[
                      { 'md-valid': !errors.has('bank') && touched.bank },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('bank') },
                    ]"
                  >
                    <md-icon>domain</md-icon>
                    <label>Banco</label>
                    <md-select
                      v-model="providerInfo.bank"
                      data-vv-name="bank"
                      name="bank"
                      required
                      v-validate="bankEditValidations.bank"
                    >
                      <md-option
                        v-for="bank in banks"
                        :key="bank.id"
                        :value="bank.id"
                      >{{ bank.short_name }}</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div v-show="modifyBank" class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('account_number') &&
                          touched.account_number,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('account_number') },
                    ]"
                  >
                    <md-icon>attach_money</md-icon>
                    <label>Número de cuenta</label>
                    <md-input
                      v-model="providerInfo.accountNumber"
                      data-vv-name="account_number"
                      type="number"
                      name="account_number"
                      v-validate="bankEditValidations.account_number"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('account_number')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="
                          !errors.has('account_number') &&
                          touched.account_number
                        "
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div v-show="modifyBank" class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="[
                      { 'md-valid': !errors.has('clabe') && touched.clabe },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('clabe') },
                    ]"
                  >
                    <md-icon>account_balance</md-icon>
                    <label>CLABE</label>
                    <md-input
                      v-model="providerInfo.clabe"
                      data-vv-name="clabe"
                      type="number"
                      name="clabe"
                      v-validate="bankEditValidations.clabe"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('clabe')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="!errors.has('clabe') && touched.clabe">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div v-show="modifyBank" class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('card_number') && touched.card_number,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('card_number') },
                    ]"
                  >
                    <md-icon>payment</md-icon>
                    <label>Número de tarjeta</label>
                    <md-input
                      v-model="providerInfo.cardNumber"
                      data-vv-name="card_number"
                      type="number"
                      name="card_number"
                      v-validate="bankEditValidations.card_number"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('card_number')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="
                          !errors.has('card_number') && touched.card_number
                        "
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div
                  v-show="modifyBank"
                  class="md-layout-item md-size-100 mx-auto md-small-size-100"
                >
                  <md-field
                    :class="[
                      {
                        'md-valid':
                          !errors.has('reference') && touched.reference,
                      },
                      { 'md-form-group': true },
                      { 'md-error': errors.has('reference') },
                    ]"
                  >
                    <md-icon>send</md-icon>
                    <label>Referencia</label>
                    <md-input
                      v-model="providerInfo.reference"
                      data-vv-name="reference"
                      type="text"
                      name="reference"
                      v-validate="bankEditValidations.reference"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="errors.has('reference')">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        class="success"
                        v-show="!errors.has('reference') && touched.reference"
                      >done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div
                  v-show="modifyContact"
                  class="md-layout-item md-size-100 mt-2 md-small-size-100"
                >
                  <contact-data :contactData="providerInfo.contact" :modify="modifyContact"></contact-data>
                </div>

                <div
                  v-if="modifySecondContact"
                  class="md-layout-item md-size-100 mt-2 md-small-size-100"
                >
                  <contact-address :address="providerInfo.contact.secondAddress"></contact-address>
                </div>

                <div class="md-layout">
                  <div class="md-layout">
                    <label class="md-layout-item md-size-25 md-form-label"></label>
                    <div class="md-layout-item">
                      <md-checkbox v-model="providerInfo.hasTools" class="md-primary">
                        <md-icon>build</md-icon>¿Tiene herramienta?
                      </md-checkbox>
                    </div>
                  </div>

                  <div class="md-layout">
                    <label class="md-layout-item md-size-25 md-form-label"></label>
                    <div class="md-layout-item">
                      <md-checkbox v-model="providerInfo.hasVehicle" class="md-primary">
                        <md-icon>directions_car</md-icon>¿Tiene transporte?
                      </md-checkbox>
                    </div>
                  </div>

                  <div class="md-layout">
                    <label class="md-layout-item md-size-25 md-form-label"></label>
                    <div class="md-layout-item">
                      <md-checkbox v-model="providerInfo.hasCellphone">
                        <md-icon>smartphone</md-icon>¿Tiene celular?
                      </md-checkbox>
                    </div>
                  </div>
                </div>
              </form>

              <div class="md-layout" xv-if="modifyContact || modifySecondContact || modifyBank">
                <div class="md-layout-item md-size-25 mx-auto">
                  <md-button type="submit" form="provider_form" class="md-success">Modificar</md-button>
                </div>
              </div>
            </tab>
            <tab name="Archivos">
              <edit-files
                :providerId="providerInfo.providerData.id"
                :pFiles="providerInfo.providerData.files"
              ></edit-files>
            </tab>
          </tabs>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import ContactData from "./wizard/ContactData";
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";
import RegisterProviderType from "./wizard/RegisterProviderType";
import RegisterCoreBusiness from "./wizard/RegisterCoreBusiness";
import providesValidatorMixin from "@/mixins/providesValidator";
import ContactAddress from "./wizard/Address";
import providerService from "@/services/provider";
import EditFiles from "./editFiles";

const touched = {
  providerType: false,
  coreBusiness: false,
  commercialName: false,
  rfc: false,
  capacity: false,
  bill_zone: false,
  camps: false,
  bank: false,
  account_number: false,
  clabe: false,
  card_number: false,
};

const bankValidations = {
  rfc: {
    min: 12,
    max: 13,
  },
  bank: {
    required: true,
  },
  account_number: {
    required: true,
    numeric: true,
    min: 7,
    max: 15,
  },
  clabe: {
    required: true,
    numeric: true,
    min: 18,
    max: 18,
  },
  card_number: {
    required: false,
    numeric: true,
    min: 16,
    max: 18,
  },
  reference: {},
};

const modelValidations = {
  providerType: {
    required: true,
  },
  coreBusiness: {
    required: true,
  },
  camps: {
    required: true,
  },
  commercialName: {
    required: true,
    min: 5,
  },
  capacity: {
    numeric: true,
    min_value: 1,
  },
  bill_zone: {},
  ...bankValidations,
};

export default {
  name: "ProviderDetails",
  components: {
    SlideYDownTransition,
    ContactData,
    RegisterProviderType,
    RegisterCoreBusiness,
    ContactAddress,
    EditFiles,
  },
  mixins: [providesValidatorMixin],
  data() {
    return {
      id: this.$route.params.id,
      modifyBank: false,
      modifyContact: false,
      modifySecondContact: false,
      mCamps: [],
      mProviderTypes: [],
      mCoreBusiness: [],
      mStates: [],
      mMunicipality: [],
      touched,
      modelValidations,
      banks: [],
      IDSecondAdd: 0,
      providerInfo: {},
    };
  },
  mounted() {
    providerService.fetchProvider(this.id).then((res) => {
      this.providerInfo = res;
    });
    catalogService
      .fetch("provider_type")
      .then((res) => (this.mProviderTypes = res));
    catalogService
      .fetch("core_business")
      .then((res) => (this.mCoreBusiness = res));
    catalogService.fetch("common/states").then((res) => (this.mStates = res));
    catalogService.fetch("highway/camp").then((res) => (this.mCamps = res));
    catalogService.fetch("banks").then((res) => (this.banks = res));
  },
  computed: {
    isFilled() {
      return Object.keys(this.providerInfo).length !== 0;
    },
    bankEditValidations() {
      const { modifyBank } = this;
      if (!modifyBank) {
        return Object.fromEntries(
          Object.entries(bankValidations).map(([field, validations]) => [
            field,
            { ...validations, required: false },
          ])
        );
      } else {
        return bankValidations;
      }
    },
  },
  methods: {
    applyClass() {
      if (this.providerInfo.providerData.status === "A prueba") return "blue";
      if (this.providerInfo.providerData.status === "Activo") return "green";
      if (this.providerInfo.providerData.status === "Condicionado")
        return "orange";
      if (this.providerInfo.providerData.status === "Bloqueado") return "red";
      return "";
    },
    updateMunicipality(state) {
      return catalogService
        .fetch("common/states", state)
        .then((data) => (this.mMunicipality = data.Municipality));
    },
    selectedMunicipality(id) {
      return this.mMunicipality.find((mun) => mun.id === id);
    },
    submit() {
      this.isValid().then((res) => {
        if (res) {
          this.updateMunicipality(this.providerInfo.contact.address.state);
          providerService
            .updateProvider(this.providerInfo)
            .then(() =>
              this.$successMessage({
                title: "Datos Modificados!",
                text: "Datos del proveedor modificados correctamente",
              })
            )
            .catch(this.$fireErrorResponse);
        } else {
          const errors = this.errors.collect();
          this.$alertMessage({
            timer: 2000,
            title: "Error en formulario",
            text: "Compruebe que todos los datos esten llenados correctamente",
            footer: JSON.stringify(errors),
          });
        }
      });
    },
    isValid() {
      return this.$validator.validateAll().then((res) => res);
    },
  },
  watch: {
    coreBusiness() {
      this.touched.coreBusiness = true;
    },
    providerType() {
      this.touched.providerType = true;
    },
    firstName() {
      this.touched.firstName = true;
    },
    lastName() {
      this.touched.lastName = true;
    },
    mothersLastName() {
      this.touched.mothersLastName = true;
    },
    bill_zone() {
      this.touched.bill_zone = true;
    },
    camps() {
      this.touched.camps = true;
    },
    modifyBank() {
      if (this.modifyBank) {
        this.modifyContact = false;
        this.modifySecondContact = false;
      }
    },
    modifyContact() {
      if (this.modifyContact) {
        this.modifyBank = false;
        this.modifySecondContact = false;
      }
    },
    modifySecondContact() {
      if (this.modifySecondContact) {
        this.modifyBank = false;
        this.modifyContact = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.blue {
  color: blue !important;
}
.green {
  color: green !important;
}
.orange {
  color: orange !important;
}
.red {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Providers/modifyProvider.vue